import type { PropsWithChildren } from "react";

export function ContentWrapper({ children, className }: PropsWithChildren<{ className?: string }>) {
  return (
    <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ${className || ""}`}>{children}</div>
  );
}
